import { createStyles, IconButton, makeStyles, Paper } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

import { TimesIcon } from "../../assets/icons";
import { RelodeTheme } from "../styles";
import { Text } from "../text";
import { NotificationIcon } from "./notificationIcon";
import { NotificationLevel } from "./types";

interface SnackProps {
    level: NotificationLevel;
    message: React.ReactNode;
    autoHide?: boolean;
    onClose?: () => void;
    canClose?: boolean;
    customIcon?: React.ReactElement<SvgIconProps>;
}

const useSnackStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                height: 70,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: theme.spacing(0, 2),
                width: 350,
            },
            icon: {
                paddingRight: 16,
                fontSize: 40,
                display: "flex",
            },
            message: {
                flexGrow: 1,
                marginTop: -4,
            },
            close: {
                justifySelf: "flex-end",
                color: "gray",
            },
        }),
    { name: "Snack" }
);

export const Snack = React.forwardRef((props: SnackProps, ref: any) => {
    const classes = useSnackStyles({});

    const closeSnack = () => {
        if (props.onClose) props.onClose();
    };

    return (
        <Paper elevation={8} ref={ref} className={classes.root}>
            <NotificationIcon
                level={props.level}
                size="inherit"
                className={classes.icon}
                customIcon={props.customIcon}
            />
            <div className={classes.message}>
                <Text variant="body1">{props.message}</Text>
            </div>
            {!props.autoHide || props.canClose ? (
                <IconButton
                    className={classes.close}
                    onClick={closeSnack}
                    color="primary"
                >
                    <TimesIcon fontSize="small" />
                </IconButton>
            ) : null}
        </Paper>
    );
});
